import { Model } from 'vue-models'
import TextField from './types/TextField'

export default class Vessel extends Model {
  static defaults () {
    return {
      name: 'vessel',
      computed: {
        __str__ () {
          if (this.name && this.imo) {
            return `${this.name} (${this.imo})`
          } else if (!this.name && this.imo) {
            return `${this.imo}`
          }
          return this.name
        }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      name: { type: TextField },
      imo: { type: TextField }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/vessel.js